import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-acbcf27e")

_pushScopeId("data-v-acbcf27e")
const _hoisted_1 = { class: "wf-body" }
const _hoisted_2 = { class: "wf-screen wf-bg-black" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = {
  target: "_blank",
  class: "card mr-3 px-1 py-1 wf-partner-link",
  style: {"flex":"1"},
  ref: "forbesLink",
  href: "https://www.forbes.ru/rating-photogallery/292533-25-samykh-vygodnykh-franshiz-v-rossii-2015-reiting-forbes?photo=16"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("h5", { class: "m-2" }, "Топ25 Forbes 2015", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "pi pi-external-link" }, null, -1)
const _hoisted_7 = {
  target: "_blank",
  class: "card px-2 py-1 wf-partner-link",
  style: {"flex":"1"},
  ref: "bebossLink",
  href: "https://www.beboss.ru/franchise/1902-franshiza-vell"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("h5", { class: "m-2" }, "Мы в Бибосс", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "pi pi-external-link" }, null, -1)
const _hoisted_10 = { class: "wf-color-paper my-3 wf-text-p-shadow" }
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode()
const _hoisted_13 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createTextVNode(" под брендом "),
  /*#__PURE__*/_createVNode("span", null, "Велл")
], -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("h4", {
  style: {"color":"var(--yellow-500)"},
  class: "wf-text-p-shadow text-normal wf-substrate"
}, [
  /*#__PURE__*/_createTextVNode(" Старт с минимальными затратами,"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" без вступительного взноса."),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" Повышенная комиссия,"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" без планов продаж.")
], -1)
const _hoisted_15 = { ref: "heroSubmit" }
const _hoisted_16 = {
  class: "wf-screen wf-bg-blue-50",
  id: "about"
}
const _hoisted_17 = { class: "wf-container px-3" }
const _hoisted_18 = /*#__PURE__*/_createVNode("h2", { class: "mt-6" }, "О нас", -1)
const _hoisted_19 = { class: "grid pt-3" }
const _hoisted_20 = { class: "col-6 lg:col-3" }
const _hoisted_21 = { class: "mt-0 mb-4 text-normal" }
const _hoisted_22 = { class: "wf-hero-number" }
const _hoisted_23 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" лет на рынке ")
const _hoisted_25 = { class: "col-6 lg:col-3" }
const _hoisted_26 = { class: "mt-0 mb-4 text-normal" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("в ")
const _hoisted_28 = { class: "wf-hero-number" }
const _hoisted_29 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" городах ")
const _hoisted_31 = { class: "col-6 lg:col-3" }
const _hoisted_32 = { class: "mt-0 mb-4 text-normal" }
const _hoisted_33 = { class: "wf-hero-number" }
const _hoisted_34 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" действующих агентства ")
const _hoisted_36 = { class: "md:col-6 lg:col-6" }
const _hoisted_37 = { class: "mt-0 mb-4 text-normal" }
const _hoisted_38 = { class: "wf-hero-number" }
const _hoisted_39 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" туристов ежегодно ")
const _hoisted_41 = { class: "md:col-6 lg:col-6" }
const _hoisted_42 = { class: "mt-0 mb-4 text-normal" }
const _hoisted_43 = { class: "wf-hero-number" }
const _hoisted_44 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" отдохнуло с ВЕЛЛ ")
const _hoisted_46 = {
  style: {"background-color":"var(--blue-400)"},
  class: "wf-screen  wf-screen-fluid pb-6",
  id: "vimeo"
}
const _hoisted_47 = { class: "wf-container px-3" }
const _hoisted_48 = /*#__PURE__*/_createVNode("h2", {
  style: {"color":"var(--paper)"},
  class: "mt-6"
}, "Видео отзывы партнеров ", -1)
const _hoisted_49 = { class: "pt-3" }
const _hoisted_50 = /*#__PURE__*/_createVNode("i", { class: "pi pi-caret-right wf-play" }, null, -1)
const _hoisted_51 = {
  class: "wf-screen",
  style: {"background-color":"var(--blue-400)"},
  id: "services"
}
const _hoisted_52 = { class: "wf-container px-3" }
const _hoisted_53 = /*#__PURE__*/_createVNode("h2", {
  style: {"color":"var(--paper)"},
  class: "mt-6"
}, "Наши преимущества", -1)
const _hoisted_54 = { class: "grid pt-3" }
const _hoisted_55 = { class: "p-2 flex flex-column align-items-center" }
const _hoisted_56 = { class: "mt-0 mb-1 text-center wf-service-text wf-substrate-paper" }
const _hoisted_57 = {
  class: "wf-screen wf-bg-blue-50",
  id: "reviews"
}
const _hoisted_58 = { class: "wf-container px-3" }
const _hoisted_59 = /*#__PURE__*/_createVNode("h2", { class: "mt-6" }, "Что говорят наши агенты", -1)
const _hoisted_60 = {
  class: "wf-screen wf-bg-yellow-200",
  id: "director"
}
const _hoisted_61 = { class: "wf-container px-3" }
const _hoisted_62 = /*#__PURE__*/_createVNode("h2", { class: "mt-6" }, "Постройте туристический бизнес вместе с Велл", -1)
const _hoisted_63 = /*#__PURE__*/_createVNode("div", { class: "md:col-6 sm-12 px-0 pb-6" }, [
  /*#__PURE__*/_createVNode("h3", { class: "text-normal" }, "Уважаемые друзья, будущие и настоящие предприниматели!"),
  /*#__PURE__*/_createVNode("p", null, "Миссия нашей компании — сделать предпринимательство в сфере туризма более доступным, удобным и выгодным."),
  /*#__PURE__*/_createVNode("p", null, "Сегодня в мире более полумиллиарда предпринимателей. У каждого из них был свой путь к созданию бизнеса, ведь единственно правильного способа стать предпринимателем не существует. "),
  /*#__PURE__*/_createVNode("p", null, "Присоединяйтесь к нашей сети туристических агентств Велл, и мы поможем Вам найти свою предпринимательскую дорогу, избежать ошибок и построить успешный бизнес в сфере туризма."),
  /*#__PURE__*/_createVNode("p", { class: "mt-4 mb-0" }, "Генеральный директор Велл"),
  /*#__PURE__*/_createVNode("h5", { class: "m-0" }, "Екатерина Маяцкая")
], -1)
const _hoisted_64 = {
  class: "wf-screen",
  style: {"background-color":"var(--blue-400)"},
  id: "preferences"
}
const _hoisted_65 = { class: "wf-container px-3" }
const _hoisted_66 = /*#__PURE__*/_createVNode("h2", {
  style: {"color":"var(--paper)"},
  class: "mt-6"
}, " Чем туризм выгоднее других сфер ", -1)
const _hoisted_67 = { class: "grid pt-3" }
const _hoisted_68 = { class: "2 flex flex-column align-items-center" }
const _hoisted_69 = { class: "mx-lg:col-6 mt-0 mb-2 text-center wf-service-text wf-substrate-paper" }
const _hoisted_70 = {
  key: 0,
  class: "mx-lg:col-6 mt-1 mb-2 text-center wf-service-text-sub"
}
const _hoisted_71 = {
  class: "wf-screen  wf-bg-blue-50",
  id: "cost"
}
const _hoisted_72 = { class: "wf-container px-3" }
const _hoisted_73 = /*#__PURE__*/_createVNode("h2", { class: "mt-6 mb-3" }, "Примерные затраты на открытие офиса", -1)
const _hoisted_74 = { class: "grid" }
const _hoisted_75 = { class: "col" }
const _hoisted_76 = { class: "wf-office-image" }
const _hoisted_77 = /*#__PURE__*/_createVNode("h4", { class: "text-normal m-0" }, "В административном здании", -1)
const _hoisted_78 = { class: "py-1 wf-list-item" }
const _hoisted_79 = /*#__PURE__*/_createTextVNode(" Аренда помещения ")
const _hoisted_80 = /*#__PURE__*/_createVNode("div", { class: "p-chip-text" }, [
  /*#__PURE__*/_createTextVNode(" 15 м"),
  /*#__PURE__*/_createVNode("sup", { style: {"line-height":"0"} }, "2")
], -1)
const _hoisted_81 = /*#__PURE__*/_createTextVNode(" от ")
const _hoisted_82 = { class: "py-1 wf-list-item" }
const _hoisted_83 = /*#__PURE__*/_createTextVNode(" Дизайн макета ")
const _hoisted_84 = /*#__PURE__*/_createVNode("span", { class: "p-chip-icon pi pi-check wf-color-paper" }, null, -1)
const _hoisted_85 = /*#__PURE__*/_createVNode("div", { class: "p-chip-text wf-color-paper" }, "Бесплатно", -1)
const _hoisted_86 = { class: "py-1 wf-list-item" }
const _hoisted_87 = /*#__PURE__*/_createTextVNode(" Вывеска от ")
const _hoisted_88 = { class: "py-1 wf-list-item" }
const _hoisted_89 = /*#__PURE__*/_createTextVNode(" Плакаты с логотипом от ")
const _hoisted_90 = { class: "py-1 wf-list-item" }
const _hoisted_91 = /*#__PURE__*/_createTextVNode(" Мебель от ")
const _hoisted_92 = { class: "py-1 wf-list-item" }
const _hoisted_93 = /*#__PURE__*/_createTextVNode(" Орг. техника от ")
const _hoisted_94 = { class: "py-1 wf-list-item wf-bg-yellow-200" }
const _hoisted_95 = /*#__PURE__*/_createTextVNode(" Первые вложения примерно составят ")
const _hoisted_96 = { class: "py-1 wf-list-item wf-bg-orange-200" }
const _hoisted_97 = /*#__PURE__*/_createTextVNode(" Срок окупаемости от ")
const _hoisted_98 = { class: "col" }
const _hoisted_99 = { class: "wf-office-image" }
const _hoisted_100 = /*#__PURE__*/_createVNode("h4", { class: "text-normal m-0" }, "В Торговом Центре", -1)
const _hoisted_101 = { class: "py-1 wf-list-item" }
const _hoisted_102 = /*#__PURE__*/_createTextVNode(" Аренда помещения ")
const _hoisted_103 = /*#__PURE__*/_createVNode("div", { class: "p-chip-text" }, [
  /*#__PURE__*/_createTextVNode(" 15 м"),
  /*#__PURE__*/_createVNode("sup", { style: {"line-height":"0"} }, "2")
], -1)
const _hoisted_104 = /*#__PURE__*/_createTextVNode(" от ")
const _hoisted_105 = { class: "py-1 wf-list-item" }
const _hoisted_106 = /*#__PURE__*/_createTextVNode(" Дизайн макета ")
const _hoisted_107 = /*#__PURE__*/_createVNode("span", { class: "p-chip-icon pi pi-check wf-color-paper" }, null, -1)
const _hoisted_108 = /*#__PURE__*/_createVNode("div", { class: "p-chip-text wf-color-paper" }, "Бесплатно", -1)
const _hoisted_109 = { class: "py-1 wf-list-item" }
const _hoisted_110 = /*#__PURE__*/_createTextVNode(" Вывеска от ")
const _hoisted_111 = { class: "py-1 wf-list-item" }
const _hoisted_112 = /*#__PURE__*/_createTextVNode(" Плакаты с логотипом от ")
const _hoisted_113 = { class: "py-1 wf-list-item" }
const _hoisted_114 = /*#__PURE__*/_createTextVNode(" Мебель от ")
const _hoisted_115 = { class: "py-1 wf-list-item" }
const _hoisted_116 = /*#__PURE__*/_createTextVNode(" Орг. техника от ")
const _hoisted_117 = { class: "py-1 wf-list-item wf-bg-yellow-200" }
const _hoisted_118 = /*#__PURE__*/_createTextVNode(" Первые вложения примерно составят ")
const _hoisted_119 = { class: "py-1 wf-list-item wf-bg-orange-200" }
const _hoisted_120 = /*#__PURE__*/_createTextVNode(" Срок окупаемости от ")
const _hoisted_121 = {
  class: "wf-screen wf-bg-blue-300",
  id: "stages"
}
const _hoisted_122 = { class: "wf-container px-3" }
const _hoisted_123 = /*#__PURE__*/_createVNode("h2", { class: "mt-6" }, "Этапы открытия вашего турагентства", -1)
const _hoisted_124 = { class: "flex justify-content-center" }
const _hoisted_125 = {
  class: "wf-screen wf-bg-yellow-200",
  id: "bonuses"
}
const _hoisted_126 = { class: "wf-container px-3" }
const _hoisted_127 = /*#__PURE__*/_createVNode("h2", { class: "mt-6" }, " Что вы получаете ", -1)
const _hoisted_128 = { class: "grid pt-3 justify-content-center" }
const _hoisted_129 = { class: "2 flex flex-column align-items-center" }
const _hoisted_130 = { class: "mx-lg:col-6 mt-0 mb-2 text-center wf-service-text" }
const _hoisted_131 = {
  key: 0,
  class: "mx-lg:col-6 mt-1 mb-2 text-center wf-service-text-sub"
}
const _hoisted_132 = {
  class: "wf-screen wf-bg-yellow-50",
  id: "tariffs"
}
const _hoisted_133 = { class: "wf-container px-3" }
const _hoisted_134 = /*#__PURE__*/_createVNode("h2", { class: "mt-6" }, "Франчайзинговый пакет включает", -1)
const _hoisted_135 = { class: "pt-3" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Divider = _resolveComponent("Divider")
  const _component_Button = _resolveComponent("Button")
  const _component_SvgBackground = _resolveComponent("SvgBackground")
  const _component_SpecialOffer = _resolveComponent("SpecialOffer")
  const _component_Waypoint = _resolveComponent("Waypoint")
  const _component_Reviews = _resolveComponent("Reviews")
  const _component_Chip = _resolveComponent("Chip")
  const _component_Card = _resolveComponent("Card")
  const _component_Stages = _resolveComponent("Stages")
  const _component_SingleTariff = _resolveComponent("SingleTariff")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("img", {
        src: require('@/assets/screen-1-bg.jpg'),
        alt: "Велл сеть турагентств",
        class: "wf-screen-bg"
      }, null, 8, ["src"]),
      _createVNode("div", {
        class: ["wf-screen-caption mt-6", { 'grid': !_ctx.isMobile }]
      }, [
        _createVNode("div", {
          class: ["pt-5 px-3", { 'col-6 col-offset-3': !_ctx.isMobile }],
          ref: "heroCaption"
        }, [
          _createVNode("div", _hoisted_3, [
            _createVNode("a", _hoisted_4, [
              _createVNode("img", {
                class: "wf-partner-logo",
                alt: "топ 25 франшиз Forbes",
                src: require('@/assets/forbes.svg')
              }, null, 8, ["src"]),
              _createVNode(_component_Divider, {
                type: "dashed",
                layout: _ctx.isMobile ? 'horizontal' : 'vertical',
                class: [{ 'mr-3': !_ctx.isMobile }, "my-1"]
              }, null, 8, ["layout", "class"]),
              _hoisted_5,
              _hoisted_6
            ], 512),
            _createVNode("a", _hoisted_7, [
              _createVNode("img", {
                class: "wf-partner-logo",
                alt: "мы в Бибосс",
                src: require('@/assets/beboss.svg')
              }, null, 8, ["src"]),
              _createVNode(_component_Divider, {
                type: "dashed",
                layout: _ctx.isMobile ? 'horizontal' : 'vertical',
                class: [{ 'mr-3': !_ctx.isMobile }, "my-1"]
              }, null, 8, ["layout", "class"]),
              _hoisted_8,
              _hoisted_9
            ], 512)
          ]),
          _createVNode("h1", _hoisted_10, [
            _createVNode("a", {
              class: "wf-link",
              href: "javascript:;",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.proceedToOrder && _ctx.proceedToOrder(...args)))
            }, " Откройте свое турагентство "),
            _hoisted_11,
            _hoisted_12,
            _hoisted_13
          ]),
          _hoisted_14,
          _createVNode("div", _hoisted_15, [
            _createVNode(_component_Button, {
              label: "Оставить заявку",
              icon: "pi pi-envelope",
              class: "p-button-lg shadow-8",
              onClick: _ctx.proceedToOrder
            }, null, 8, ["onClick"])
          ], 512)
        ], 2)
      ], 2),
      _createVNode(_component_SvgBackground, {
        id: _ctx.isNewYear ? 'newyear' : 'hero'
      }, null, 8, ["id"])
    ]),
    _createVNode(_component_SpecialOffer),
    _createVNode("div", _hoisted_16, [
      _createVNode("div", _hoisted_17, [
        _hoisted_18,
        _createVNode("div", _hoisted_19, [
          _createVNode("div", _hoisted_20, [
            _createVNode(_component_Waypoint, {
              onChange: _cache[2] || (_cache[2] = (e) => _ctx.waypointChange(0, e))
            }),
            _createVNode("h4", _hoisted_21, [
              _createVNode("span", _hoisted_22, _toDisplayString(_ctx.numbers[0]), 1),
              _hoisted_23,
              _hoisted_24
            ])
          ]),
          _createVNode("div", _hoisted_25, [
            _createVNode(_component_Waypoint, {
              onChange: _cache[3] || (_cache[3] = (e) => _ctx.waypointChange(1, e))
            }),
            _createVNode("h4", _hoisted_26, [
              _hoisted_27,
              _createVNode("span", _hoisted_28, _toDisplayString(_ctx.numbers[1]), 1),
              _hoisted_29,
              _hoisted_30
            ])
          ]),
          _createVNode("div", _hoisted_31, [
            _createVNode(_component_Waypoint, {
              onChange: _cache[4] || (_cache[4] = (e) => _ctx.waypointChange(2, e))
            }),
            _createVNode("h4", _hoisted_32, [
              _createVNode("span", _hoisted_33, _toDisplayString(_ctx.numbers[2]), 1),
              _hoisted_34,
              _hoisted_35
            ])
          ]),
          _createVNode("div", _hoisted_36, [
            _createVNode(_component_Waypoint, {
              onChange: _cache[5] || (_cache[5] = (e) => _ctx.waypointChange(3, e))
            }),
            _createVNode("h4", _hoisted_37, [
              _createVNode("span", _hoisted_38, _toDisplayString(_ctx.numbers[3].toLocaleString('ru-RU')), 1),
              _hoisted_39,
              _hoisted_40
            ])
          ]),
          _createVNode("div", _hoisted_41, [
            _createVNode(_component_Waypoint, {
              onChange: _cache[6] || (_cache[6] = (e) => _ctx.waypointChange(4, e))
            }),
            _createVNode("h4", _hoisted_42, [
              _createVNode("span", _hoisted_43, _toDisplayString(_ctx.numbers[4].toLocaleString('ru-RU')) + "+", 1),
              _hoisted_44,
              _hoisted_45
            ])
          ])
        ]),
        _createVNode(_component_Button, {
          style: {"z-index":"2"},
          label: "Узнать больше",
          icon: "pi pi-info-circle",
          class: "p-button-lg shadow-8 p-button-warning my-3",
          onClick: _ctx.requestPresentation
        }, null, 8, ["onClick"])
      ]),
      _createVNode(_component_SvgBackground, { id: "about" })
    ]),
    _createVNode("div", _hoisted_46, [
      _createVNode("div", _hoisted_47, [
        _hoisted_48,
        _createVNode("div", _hoisted_49, [
          _createVNode("div", {
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handlePlay && _ctx.handlePlay(...args))),
            class: [{
            'is-playing': _ctx.isVideoPLaying,
          }, "flex align-items-center justify-content-center wf-player"],
            style: {"position":"relative"}
          }, [
            _hoisted_50,
            _createVNode("video", {
              src: `${require('@/assets/franchise-promo.mp4')}#t=0`,
              style: {"width":"100%"},
              preload: "none",
              poster: require('@/assets/franchise-promo-placeholder.jpg'),
              controls: _ctx.isVideoPLaying,
              ref: "video"
            }, null, 8, ["src", "poster", "controls"])
          ], 2)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_51, [
      _createVNode("div", _hoisted_52, [
        _hoisted_53,
        _createVNode("div", _hoisted_54, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.services, (service, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "col-6 lg:col-3",
              key: service
            }, [
              _createVNode("div", _hoisted_55, [
                _createVNode("img", {
                  class: "wf-service-image my-3",
                  src: require(`@/assets/icon-${index + 1}.svg`),
                  alt: "Прибыльный бизнес"
                }, null, 8, ["src"]),
                _createVNode("h4", _hoisted_56, _toDisplayString(service), 1)
              ])
            ]))
          }), 128))
        ])
      ]),
      _createVNode(_component_SvgBackground, { id: "services" })
    ]),
    _createVNode("div", _hoisted_57, [
      _createVNode("div", _hoisted_58, [
        _hoisted_59,
        _createVNode("div", {
          class: ["pt-3", { 'col-10 col-offset-1': !_ctx.isMobile }]
        }, [
          _createVNode(_component_Reviews)
        ], 2)
      ]),
      _createVNode(_component_SvgBackground, { id: "reviews" })
    ]),
    _createVNode("div", _hoisted_60, [
      _createVNode("div", _hoisted_61, [
        _hoisted_62,
        _createVNode("div", {
          class: ["pt-3", { 'flex col-8 col-offset-2': !_ctx.isMobile }]
        }, [
          _createVNode("div", {
            class: { 'col-6 mr-6': !_ctx.isMobile, 'flex justify-content-center': _ctx.isMobile }
          }, [
            _createVNode("img", {
              src: require('@/assets/director.jpg'),
              alt: "Директор Велл",
              class: "wf-director-image"
            }, null, 8, ["src"])
          ], 2),
          _hoisted_63
        ], 2)
      ]),
      _createVNode(_component_SvgBackground, { id: "director" })
    ]),
    _createVNode("div", _hoisted_64, [
      _createVNode("div", _hoisted_65, [
        _hoisted_66,
        _createVNode("div", _hoisted_67, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.preferences, (preference, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "col-6 lg:col-4",
              key: preference
            }, [
              _createVNode("div", _hoisted_68, [
                _createVNode("img", {
                  class: "wf-service-image my-4",
                  src: require(`@/assets/icon-${index + 9}.svg`),
                  alt: "Прибыльный бизнес"
                }, null, 8, ["src"]),
                _createVNode("h4", _hoisted_69, _toDisplayString(Array.isArray(preference) ? preference[0] : preference), 1),
                (Array.isArray(preference) && preference[1])
                  ? (_openBlock(), _createBlock("h5", _hoisted_70, _toDisplayString(preference[1]), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ]),
      _createVNode(_component_SvgBackground, { id: "preferences" })
    ]),
    _createVNode("div", _hoisted_71, [
      _createVNode("div", _hoisted_72, [
        _hoisted_73,
        _createVNode("div", _hoisted_74, [
          _createVNode("div", _hoisted_75, [
            _createVNode(_component_Card, null, {
              header: _withId(() => [
                _createVNode("div", _hoisted_76, [
                  _createVNode("img", {
                    alt: "Велл в административном здании",
                    src: require('@/assets/office-2.jpg')
                  }, null, 8, ["src"])
                ])
              ]),
              title: _withId(() => [
                _hoisted_77
              ]),
              content: _withId(() => [
                _createVNode("div", _hoisted_78, [
                  _hoisted_79,
                  _createVNode(_component_Chip, { class: "px-3" }, {
                    default: _withId(() => [
                      _hoisted_80
                    ]),
                    _: 1
                  }),
                  _hoisted_81,
                  _createVNode(_component_Chip, {
                    class: "px-3",
                    label: "20 000 руб."
                  })
                ]),
                _createVNode("div", _hoisted_82, [
                  _hoisted_83,
                  _createVNode(_component_Chip, {
                    icon: "pi pi-check wf-color-paper",
                    class: "wf-bg-green-500 wf-color-paper px-3"
                  }, {
                    default: _withId(() => [
                      _hoisted_84,
                      _hoisted_85
                    ]),
                    _: 1
                  })
                ]),
                _createVNode("div", _hoisted_86, [
                  _hoisted_87,
                  _createVNode(_component_Chip, {
                    class: "px-3",
                    label: "20 000 руб"
                  })
                ]),
                _createVNode("div", _hoisted_88, [
                  _hoisted_89,
                  _createVNode(_component_Chip, {
                    class: "px-3",
                    label: "2000 руб"
                  })
                ]),
                _createVNode("div", _hoisted_90, [
                  _hoisted_91,
                  _createVNode(_component_Chip, {
                    class: "px-3",
                    label: "25 000 руб"
                  })
                ]),
                _createVNode("div", _hoisted_92, [
                  _hoisted_93,
                  _createVNode(_component_Chip, {
                    class: "px-3",
                    label: "37 000 руб"
                  })
                ]),
                _createVNode("div", _hoisted_94, [
                  _hoisted_95,
                  _createVNode(_component_Chip, {
                    class: "px-3 wf-bg-yellow-300",
                    label: "104 000 руб"
                  })
                ]),
                _createVNode("div", _hoisted_96, [
                  _hoisted_97,
                  _createVNode(_component_Chip, {
                    class: "px-3 wf-bg-orange-300",
                    label: "3 месяцев"
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_98, [
            _createVNode(_component_Card, null, {
              header: _withId(() => [
                _createVNode("div", _hoisted_99, [
                  _createVNode("img", {
                    alt: "Велл в Торговом Центре",
                    src: require('@/assets/office-1.jpg')
                  }, null, 8, ["src"])
                ])
              ]),
              title: _withId(() => [
                _hoisted_100
              ]),
              content: _withId(() => [
                _createVNode("div", _hoisted_101, [
                  _hoisted_102,
                  _createVNode(_component_Chip, { class: "px-3" }, {
                    default: _withId(() => [
                      _hoisted_103
                    ]),
                    _: 1
                  }),
                  _hoisted_104,
                  _createVNode(_component_Chip, {
                    class: "px-3",
                    label: "30 000 руб."
                  })
                ]),
                _createVNode("div", _hoisted_105, [
                  _hoisted_106,
                  _createVNode(_component_Chip, {
                    icon: "pi pi-check wf-color-paper",
                    class: "wf-bg-green-500 wf-color-paper px-3"
                  }, {
                    default: _withId(() => [
                      _hoisted_107,
                      _hoisted_108
                    ]),
                    _: 1
                  })
                ]),
                _createVNode("div", _hoisted_109, [
                  _hoisted_110,
                  _createVNode(_component_Chip, {
                    class: "px-3",
                    label: "40 000 руб"
                  })
                ]),
                _createVNode("div", _hoisted_111, [
                  _hoisted_112,
                  _createVNode(_component_Chip, {
                    class: "px-3",
                    label: "2 000 руб"
                  })
                ]),
                _createVNode("div", _hoisted_113, [
                  _hoisted_114,
                  _createVNode(_component_Chip, {
                    class: "px-3",
                    label: "25 000 руб"
                  })
                ]),
                _createVNode("div", _hoisted_115, [
                  _hoisted_116,
                  _createVNode(_component_Chip, {
                    class: "px-3",
                    label: "37 000 руб"
                  })
                ]),
                _createVNode("div", _hoisted_117, [
                  _hoisted_118,
                  _createVNode(_component_Chip, {
                    class: "px-3 wf-bg-yellow-300",
                    label: "134 000 руб"
                  })
                ]),
                _createVNode("div", _hoisted_119, [
                  _hoisted_120,
                  _createVNode(_component_Chip, {
                    class: "px-3 wf-bg-orange-300",
                    label: "3 месяцев"
                  })
                ])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createVNode(_component_SvgBackground, { id: "steps" })
    ]),
    _createVNode("div", _hoisted_121, [
      _createVNode("div", _hoisted_122, [
        _hoisted_123,
        _createVNode("div", {
          class: ["pt-3", { 'col-8 col-offset-2': !_ctx.isMobile }]
        }, [
          _createVNode(_component_Stages),
          _createVNode("div", _hoisted_124, [
            _createVNode(_component_Button, {
              label: "Оставить заявку",
              icon: "pi pi-envelope",
              class: "p-button-lg shadow-8 my-6",
              onClick: _ctx.proceedToOrder
            }, null, 8, ["onClick"])
          ])
        ], 2)
      ]),
      _createVNode(_component_SvgBackground, { id: "reviews" })
    ]),
    _createVNode("div", _hoisted_125, [
      _createVNode("div", _hoisted_126, [
        _hoisted_127,
        _createVNode("div", _hoisted_128, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bonuses, (bonus, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "col-6 lg:col-3",
              key: bonus
            }, [
              _createVNode("div", _hoisted_129, [
                _createVNode("img", {
                  class: "wf-service-image my-4",
                  src: require(`@/assets/icon-${index + 15}.svg`),
                  alt: "Прибыльный бизнес"
                }, null, 8, ["src"]),
                _createVNode("h4", _hoisted_130, _toDisplayString(Array.isArray(bonus) ? bonus[0] : bonus), 1),
                (Array.isArray(bonus) && bonus[1])
                  ? (_openBlock(), _createBlock("h5", _hoisted_131, _toDisplayString(bonus[1]), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ]),
      _createVNode(_component_SvgBackground, { id: "bonuses" })
    ]),
    _createVNode("div", _hoisted_132, [
      _createVNode("div", _hoisted_133, [
        _hoisted_134,
        _createVNode("div", _hoisted_135, [
          _createVNode(_component_SingleTariff)
        ])
      ])
    ])
  ]))
})